<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="flex flex-wrap items-center justify-between w-full pb-2 font-poppins">
    <div class="flex items-center gap-2 text-sm text-black">
      <div class="relative">
        <select
          v-model="currentItemsPerPage"
          class="appearance-none bg-gray-100 text-black py-1 pl-3 pr-6 ml-5 rounded focus:outline-none focus:ring-2 focus:ring-gray-200 cursor-pointer text-sm font-medium"
        >
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <div
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-black"
        >
          <Icon icon="mynaui:chevron-down" class="size-4" />
        </div>
      </div>
      <span>{{ $t('admin.perPage') }}</span>
    </div>

    <div class="flex items-center gap-4 text-sm text-black">
      <span>
        <span class="font-medium text-black bg-gray-100 px-2 py-0.5 rounded">{{ page }}</span>
        {{ $t('admin.of') }} {{ totalPages }} {{ $t('admin.page')
        }}<span v-if="totalPages > 1">s</span>
      </span>

      <div class="flex items-center gap-1">
        <button
          @click="prevPage"
          :disabled="page <= 1"
          class="p-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-gray-600"
        >
          <Icon icon="mynaui:chevron-left" class="w-5 h-5" />
        </button>

        <button
          @click="nextPage"
          :disabled="page >= totalPages"
          class="p-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-gray-600"
        >
          <Icon icon="mynaui:chevron-right" class="w-5 h-5" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { Icon } from '@iconify/vue'

const props = withDefaults(
  defineProps<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    items: any[]
    itemsPerPage?: number
  }>(),
  {
    itemsPerPage: 10,
  },
)

const page = ref(1)
const currentItemsPerPage = ref(props.itemsPerPage)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const paginatedItems = defineModel<any[]>()

const itemsCount = computed(() => props.items.length)
const totalPages = computed(() => {
  const count = Math.ceil(itemsCount.value / currentItemsPerPage.value)
  return count > 0 ? count : 1
})

const updatePaginatedItems = () => {
  const start = (page.value - 1) * currentItemsPerPage.value
  const end = start + currentItemsPerPage.value
  paginatedItems.value = props.items.slice(start, end)

  scrollToTop()
}

const prevPage = () => {
  if (page.value > 1) {
    page.value--
  }
}

const nextPage = () => {
  if (page.value < totalPages.value) {
    page.value++
  }
}

const scrollToTop = () => {
  const sectionTitle = document.querySelector('.SectionTitle')
  if (sectionTitle) {
    sectionTitle.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

// Watchers
onMounted(() => updatePaginatedItems())

watch(page, () => updatePaginatedItems())

watch(
  () => props.items,
  () => {
    page.value = 1
    updatePaginatedItems()
  },
)

watch(currentItemsPerPage, () => {
  page.value = 1
  updatePaginatedItems()
})
</script>
